import { ComponentPropsWithRef, forwardRef } from 'react';

import styled from 'styled-components';

import { useNavigationSidebarContext } from 'features/main/hooks/useNavigationSidebarContext';

import { BreakpointSelectors } from '../theme';
import { PAGE_GRID_AREAS, PAGE_GRID_CLASSES, PAGE_GRID_TRACKS } from './constants';

export const Page = forwardRef<HTMLDivElement, ComponentPropsWithRef<'div'>>((props, ref) => {
  const { mode } = useNavigationSidebarContext();

  return <StyledPage ref={ref} id="page" {...props} $hasPadding={mode !== 'hidden'} />;
});

//export const Page = forwardRef<HTMLDivElement, ComponentPropsWithRef<'div'>>((props, ref) => <StyledPage ref={ref} id="page" {...props} />);

Page.displayName = 'Page';

const StyledPage = styled.div<{ $hasPadding: boolean }>`
  display: grid;
  // The following uses named grid areas to allow for easy and precise placement of child elements.
  // Here's a good overview of this technique: https://www.youtube.com/watch?v=cf-J4ffMBfo&t=67s
  grid-template-columns:
    [ ${PAGE_GRID_TRACKS.FlushStart}] ${({ $hasPadding, theme }) => ($hasPadding ? theme.space.spacing20 : 0)}
    [ ${PAGE_GRID_TRACKS.ContentStart}] minmax(0, 1fr)
    [ ${PAGE_GRID_TRACKS.ContentEnd}] ${({ $hasPadding, theme }) => ($hasPadding ? theme.space.spacing20 : 0)}
    [ ${PAGE_GRID_TRACKS.FlushEnd}];
  grid-template-rows: min-content 1fr;
  row-gap: ${({ theme }) => theme.space.spacing10};

  ${BreakpointSelectors.VerticalClamp} & {
    overflow-y: hidden;
  }

  & > .${PAGE_GRID_CLASSES.Flush} {
    grid-column: ${PAGE_GRID_AREAS.Flush};
  }

  & > *:not(.${PAGE_GRID_CLASSES.Flush}),
  & > .${PAGE_GRID_CLASSES.Content} {
    grid-column: ${PAGE_GRID_AREAS.Content};
  }
`;
